import React from 'react'
import styled from 'styled-components'
import ErrorIcon from '../components/icons/ErrorIcon'

const GeneralErrorWrapper = styled.div`
  height: 100%;
  display: flex;
  background: #333;

  svg {
    align-self: flex-end;
    position: absolute;
  }
`
const ErrorMessagesWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  flex-basis: 60%;
  z-index: 100;
  margin: 0 auto;
`
const PrimaryInfo = styled.p`
  font-family: 'Flanders Art Sans', sans-serif;
  font-size: 64px;
  line-height: 1.55;
  text-align: center;
  color: #fafafa;
  max-width: 750px;
  strong {
    font-weight: bold;
  }
`
const SecondaryInfo = styled.p`
  font-family: 'Flanders Art Sans', sans-serif;
  max-width: 950px;
  text-align: center;
  color: #fafafa;
  font-size: 48px;
  line-height: 1.5;
  text-align: center;
  color: #fafafa;
  strong {
    font-weight: bold;
  }
`

const GeneralError = () => {
  return (
    <GeneralErrorWrapper>
      <ErrorIcon />
      <ErrorMessagesWrapper>
        <PrimaryInfo>
          Dit scherm is tijdelijk <strong>buiten dienst.</strong>
        </PrimaryInfo>
        <SecondaryInfo>
          In de <strong>app</strong> en op <strong>delijn.be</strong> kan je
          zien wanneer je bus of tram aankomt!
        </SecondaryInfo>
      </ErrorMessagesWrapper>
    </GeneralErrorWrapper>
  )
}

export default GeneralError
